import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#daily-mortgage-rate-trends-v2-app', App);
